export default __webpack_public_path__ + "static/media/0000.71c0f24a.png";